import { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import UserContext from '../../libs/context';
import { WarnAlert } from '../user/alert';
import {
  RESTRICTED_MESSAGE,
  isCapabilityBlocked,
  isRestricted,
} from '../../libs/restrictions';

// PB-2323: one generic banner for any restriction. It never says which kind or why.
export const RestrictionBanner = () => {
  const { restrictions } = useContext(UserContext) || {};
  if (!isRestricted(restrictions)) {
    return null;
  }
  return (
    <div data-testid="restriction-banner">
      <WarnAlert message={RESTRICTED_MESSAGE} />
    </div>
  );
};

// Route-level gate: a page whose whole purpose is a blocked action (deposit, withdraw, add a
// whitelist, a new subscription) shows a notice instead of its form. The page re-checks on mount,
// so a block applied mid-session takes effect on the next visit without a re-login.
export const RestrictionGate = ({ capability, children }) => {
  const { restrictions, refreshRestrictions } = useContext(UserContext) || {};

  useEffect(() => {
    if (refreshRestrictions) {
      refreshRestrictions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [capability]);

  if (!isCapabilityBlocked(restrictions, capability)) {
    return children;
  }
  return (
    <div className="nk-block" data-testid={`restriction-gate-${capability}`}>
      <WarnAlert message={RESTRICTED_MESSAGE}>
        <Link to="/portal/wallet" className="btn btn-sm btn-primary">
          Back to Wallet
        </Link>
      </WarnAlert>
    </div>
  );
};

// For a single button or link inside an otherwise usable page.
export const useCapabilityBlocked = (capability) => {
  const { restrictions } = useContext(UserContext) || {};
  return isCapabilityBlocked(restrictions, capability);
};
